//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

export const PROMOTED_POSTS_METRICS_SORT_KEY = {
  PROMOTION_SCHEDULE: undefined,
  SPEND: 'Spend',
  IMPRESSIONS: 'Impressions',
  INTERACTIONS: 'Interactions',
  CLICKS: 'Clicks',
  CPC: 'CPC',
  REVENUE: 'Revenue',
  ROAS: 'ROAS',
};

export const PROMOTED_POSTS_METRICS_SORT_DIR = {
  ASC: 'Asc',
  DESC: 'Desc',
};

export const PROMOTED_POSTS_METRICS_API_SORT_KEY = {
  [PROMOTED_POSTS_METRICS_SORT_KEY.PROMOTION_SCHEDULE]: 'Schedule',
  [PROMOTED_POSTS_METRICS_SORT_KEY.SPEND]: 'Spend',
  [PROMOTED_POSTS_METRICS_SORT_KEY.IMPRESSIONS]: 'Impressions',
  [PROMOTED_POSTS_METRICS_SORT_KEY.INTERACTIONS]: 'Interactions',
  [PROMOTED_POSTS_METRICS_SORT_KEY.CLICKS]: 'Clicks',
  [PROMOTED_POSTS_METRICS_SORT_KEY.CPC]: 'Cpc',
  [PROMOTED_POSTS_METRICS_SORT_KEY.REVENUE]: 'Revenue',
  [PROMOTED_POSTS_METRICS_SORT_KEY.ROAS]: 'Roas',
};
